var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('impersonation-banner'),_vm._v(" "),(_vm.$platform === 'electron')?_c('network-status'):_vm._e(),_vm._v(" "),(_vm.isStandalone)?_c('sync'):_vm._e(),_vm._v(" "),_c('navbar'),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"content"},[(
          (!_vm.isShared &&
            !_vm.$route.name.startsWith('index__') &&
            !_vm.$route.name.startsWith('fitness__') &&
            !_vm.$route.name.startsWith('regional__')) ||
          (_vm.isShared && _vm.applications)
        )?_c('breadcrumbs'):_vm._e(),_vm._v(" "),_c('nuxt'),_vm._v(" "),(_vm.$platform === 'electron')?[_c('device-ble-modal'),_vm._v(" "),_c('bodyscan-device-modal'),_vm._v(" "),_c('device-on-warning-modal')]:_vm._e()],2)],1),_vm._v(" "),_c('GlobalLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }